import { monotonicFactory } from 'ulid';
/**
 * Monotonic, not the plain `ulid()`. Two ULIDs generated in the same
 * millisecond would otherwise differ only in their random component and could
 * sort in either order — and 00 §4.4 relies on ULIDs being time-sortable to
 * order notifications, comments and audit entries by sort key alone. The
 * monotonic factory increments the random component instead within a
 * millisecond, so creation order is always preserved.
 */
const ulid = monotonicFactory();
/**
 * ID generation (00 §4.4). Every user-visible entity ID is a short prefix, a
 * hyphen, then a Crockford-base32 ULID — time-sortable and a stable 26 chars.
 *
 * `userId` is the exception: it is Cognito's `sub` (UUID v4) mirrored verbatim,
 * so it is never produced by `newId`.
 */
export const ID_PREFIXES = [
    'u',
    'r',
    'q',
    'v',
    'rv',
    'p',
    'n',
    'msg',
    'ae',
    'job',
    'bcast',
    'pv',
];
/** DynamoDB key prefixes (00 §4.4). Used when repositories arrive (03+). */
export const KEY_PREFIX = {
    u: 'USER#',
    r: 'RESTAURANT#',
    q: 'QUEST#',
    v: 'VISIT#',
    rv: 'REVIEW#',
    p: 'PHOTO#',
    msg: 'MESSAGE#',
    ae: 'AUDIT#',
};
export function newId(prefix) {
    return `${prefix}-${ulid()}`;
}
/** A correlation ID is a bare ULID (00 §8.1) — no entity prefix. */
export function newCorrelationId() {
    return ulid();
}
const ID_PATTERN = /^([a-z]+)-([0-9A-HJKMNP-TV-Z]{26})$/;
export function isValidId(value, prefix) {
    const match = ID_PATTERN.exec(value);
    if (!match) {
        return false;
    }
    const found = match[1];
    if (!ID_PREFIXES.includes(found)) {
        return false;
    }
    return prefix === undefined || found === prefix;
}
//# sourceMappingURL=ids.js.map